export default __webpack_public_path__ + "static/1.2_IT-9e76112fe4ee69bab55d5fdd1f5b73e8.webp";